import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["textField"]

    display(event) {
        const textToDisplay = event.currentTarget.dataset.textToDisplay;
        const textField = this.textFieldTarget;

        const index = textField.value.indexOf(textToDisplay);

        if (index === -1) {
            return;
        }

        const beforeSelection = textField.value.slice(0, index);
        const linesBeforeSelection = beforeSelection.split("\n").length - 1;
        const lineHeight = parseFloat(getComputedStyle(textField).lineHeight);

        textField.scrollTo({
            top: (linesBeforeSelection * lineHeight) - lineHeight + 2,
            behavior: "auto"
        });
    }
}
